import React from 'react';
import { MdError, MdHome } from 'react-icons/md';
import './GuestError.css';

const GuestError: React.FC = () => {
  return (
    <div className="guest-error-container">
      <div className="error-background">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>
      
      <div className="error-card">
        <div className="error-header">
          <div className="error-icon">
            <MdError />
          </div>
          <h1 className="error-title">Invalid Access</h1>
          <p className="error-subtitle">
            The link you're trying to access is invalid or has expired.
          </p>
        </div>

        <div className="error-content">
          <p className="error-description">
            Please contact the hotel staff for a valid guest access link.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GuestError; 